import { HttpException, HttpStatus, Injectable } from '@nestjs/common';
import { UserEntity} from './user.entity';
import {getConnection, Repository} from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import {UserDto,LoginUserDto,CreateUserDto, updateUserDto, UpdateUserDto} from './dto/user.dto';
import {toUserDto} from './mapper';
import * as bcrypt from 'bcrypt'; 
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { UserStatusWiseResponseModel } from '@gtpl/shared-models/gtpl';
@Injectable()
export class UserService {
  constructor(
    @InjectRepository(UserEntity)    
    private readonly userRepo: Repository<UserEntity>, ) {}
  async findOne(options?: object): Promise<UserDto> {
      const user =  await this.userRepo.findOne(options);    
      return toUserDto(user);  
  }
  
  async findByLogin({ username, password }: LoginUserDto): Promise<UserDto> { 
    console.log(password); 
    const user = await this.userRepo.findOne({ where: { username } });
    console.log(user);
    if (!user ) {
      throw new ErrorResponse(11106,'User Not Found');
        // throw 'User not found, HttpStatus.UNAUTHORIZED)';    
    }
    let checkPassword = await bcrypt.compareSync(password, user.password);
    if (!checkPassword ) {
      throw new ErrorResponse(11106,'UnMatched password for the user');
        // throw 'User not found, HttpStatus.UNAUTHORIZED)';    
    }
    
    // compare passwords    
    // const areEqual = await comparePasswords(user.password, password);
    const areEqual=true;
    if (!areEqual) {
         throw 'new HttpException(Invalid credentials, HttpStatus.UNAUTHORIZED)';    
    }
    
    return toUserDto(user);  
  }
  async findByPayload({ username }: any): Promise<UserDto> {
    return await this.findOne({ 
        where:  { username } });  
  }
  async create(userDto: CreateUserDto): Promise<UserDto> {    
    const { username, password, email,role,employeeId } = userDto;
    
    // check if the user exists in the db    
    const userInDb = await this.userRepo.findOne({ 
        where: { username } 
    });
    console.log(userInDb);
    if (userInDb) {
        throw new HttpException('User already exists', HttpStatus.BAD_REQUEST);    
    }
    
    const user: UserEntity = await this.userRepo.create({ username, password, email,role,employeeId });
    await this.userRepo.save(user);
    return toUserDto(user);  
  }
  async update(userDto: updateUserDto): Promise<any> {    
    const { id,username, password, email,role,employeeId,status } = userDto;
    
    
    // check if the user exists in the db    
    const userInDb = await this.userRepo.findOne({ 
        where: { username } 
    });
    // console.log(userInDb);
    if (!userInDb) {
      throw new ErrorResponse(11106,'User not found');
      // throw new ('User not found', HttpStatus.BAD_REQUEST);    
    }
    status===undefined?true:status;
    const usrObj = password ? { id: userInDb.id, username, password, email,role,employeeId, status } : { id: userInDb.id, username, email,role,employeeId, status };
    // console.log('*****************************1')
    // console.log(userInDb.password);
    // console.log(password);
   const pswrd= await bcrypt.hash(password, 10);
  //  console.log(pswrd);
   const userEntity: UserEntity = await this.userRepo.create(usrObj);
   userEntity.password=pswrd;
    const user = await this.userRepo.save(userEntity);
    // console.log('*****************************2')
    // console.log(user);
    // userInDb.
    // try{

      // const res = await this.userRepo.save(user);
    // } catch(err){
    //   console.log(err);
    // }
    
    // console.log('hii');
    return true;  
  }
  async getEmpid(userid:Number):Promise<Number>{
    console.log('User Id'+userid);
    const userInDb = await this.userRepo.findOne({ 
      where: { id: userid} 
    });
    console.log('user service employeeId = '+userInDb.employeeId);
    return userInDb.employeeId;
  }
  async getUserInfo(userid:number):Promise<any>{
    console.log('User Id' + userid);
    const userInDb = await this.userRepo.findOne({ 
      where: { id: userid} 
    });
    console.log('user service employeeId = '+userInDb);
    return userInDb;
  }
  async getAllUsers():Promise<any>{
    // console.log();
    const users = await this.userRepo.find({});
    // console.log('user service employeeId = '+userInDb);
    return users;
  }
  async getActiveUsersCount(): Promise<UserStatusWiseResponseModel> {
    const page: number = 1;
    
    try {
      //retrieves all companies
      const usersStatusWiseCount = await getConnection()
      .createQueryBuilder()
      .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
      .from(UserEntity, "UserEntity")
      .orderBy('status','ASC')
      .getRawOne();
     
      // if (response) {
      //   response.status = true;
      //   response.active = usersStatusWiseCount.activeCount;
      //   response.inActive = usersStatusWiseCount.inActiveCount;
      //   response.total = usersStatusWiseCount.cnt;
      //   response.statusCode = 50000;
      //   response.internalMessage = 'Employees retrieved successfully';
      //   response.intlCode = 11108;
        
      // } else {
      //   throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      // }
      const response = new UserStatusWiseResponseModel(true,11108,'Employees retrieved successfully');
      return response;
    } catch (err) {
      throw err;
    }
  }
}
